import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import CustomFormDrawer from '../customFormDrawer';
import { SURVEY_TYPES } from '../../../constants/survey';
import { SUMMARY_FORM_INITIAL_DATA, getSurveySummaryFields } from './config';

const useStyles = makeStyles(({ spacing }) => ({
  summary: {
    '& .ql-container': {
      height: 376,
    },
    '& > div': {
      height: 445,
    },
  },
  subtitle: {
    marginBottom: spacing(3),
  },
  field: {
    maxWidth: 434,
  },
  selectField: {
    marginBottom: 0,
    maxWidth: 434,
  },
}));

const SurveySummaryDrawerForm = ({
  translations,
  isOpened,
  survey,
  reviews,
  questionnaires = [],
  allUsers = [],
  selectedUsers = {},
  onSave,
  onClose,
}) => {
  const classes = useStyles();
  const isSelfAssesment = survey.type === SURVEY_TYPES.SELF;

  return (
    <CustomFormDrawer
      translations={translations}
      isOpened={isOpened}
      initialData={SUMMARY_FORM_INITIAL_DATA}
      fields={getSurveySummaryFields(
        classes,
        isSelfAssesment,
        survey.isAnonymous
      )}
      allUsers={allUsers}
      reviews={reviews}
      questionnaires={questionnaires}
      survey={survey}
      selectedUsers={selectedUsers}
      onClose={onClose}
      onSave={onSave}
      hasCancelButton
      isMiddleWidth
      hideDelete
    />
  );
};

SurveySummaryDrawerForm.propTypes = {
  translations: PropTypes.object.isRequired,
  isOpened: PropTypes.bool.isRequired,
  reviews: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  questionnaires: PropTypes.arrayOf(PropTypes.shape({})),
  survey: PropTypes.object.isRequired,
  allUsers: PropTypes.arrayOf(PropTypes.shape({})),
  selectedUsers: PropTypes.object,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SurveySummaryDrawerForm;
